<template>
    <div class="text-center my-5">

        <button v-if="show" @click="loadMore" class="btn btn-primary" type="button" :disabled="isLoading">
            <i v-if="isLoading" class="fas fa-sync fa-spin mr-2"></i>
            {{ translate('show_more') }}
        </button>
    </div>
</template>

<script>
export default {
    name: "LoadMore",
    props: ['locale'],
    data() {
        return {
            page: 1,
            show: true,
            isLoading: false,

            trans: {
                'show_more': {
                    'ru': 'Показать еще',
                    'uk': 'Показати більше',
                },
            }

        }
    },
    created() {
        EventBus.$on('resetPageNumber', (last_page) => this.resetPageNumber(last_page))
    },
    methods: {
        loadMore() {
            if (history.pushState) {
                let newUrl = window.location.href.split('?')[0];
                window.history.pushState({path: newUrl}, '', newUrl);
            }
            this.page++;
            this.isLoading = true;
            axios
                .post(window.location.href.split('?')[0], {
                    'loadMore': 1,
                    'page': this.page,
                })
                .then(response => {
                    $('#products').append(response.data.products);
                    this.show = !response.data.last_page;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        resetPageNumber(last_page) {
            this.page = 1;
            this.show = !last_page;
        },
        translate(sentence) {
            return this.trans[sentence][this.locale];
        },
    },
}
</script>

<style scoped>

</style>
